import { ManualEditsLegendProvider } from './manualEditsLegend/ManualEditsLegendContext';
import { OutsideLienholderExpansionProvider } from './rows/fields/OutsideLienholderRow/OutsideLienholderExpansion';
import { ScenarioGridContent } from './ScenarioGridContent';

export { SCENARIOS_REGION_LABEL } from './ScenarioGridContent';

export const ScenarioGrid = () => (
    <OutsideLienholderExpansionProvider>
        <ManualEditsLegendProvider>
            <ScenarioGridContent />
        </ManualEditsLegendProvider>
    </OutsideLienholderExpansionProvider>
);
